import { Spinner, Typography, WithInfoIcon } from 'seagull';
import GraphWidgetTopCard from "./GraphWidgetTopCard";
import styles from "./ThreeLineTopCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ThreeLineTopCard(_ref) {
  let {
    title,
    secondaryText,
    primaryText,
    titleInfo = '',
    secondaryInfo = '',
    loading,
    success,
    testid,
    linkTo
  } = _ref;
  return /*#__PURE__*/_jsx(GraphWidgetTopCard, {
    className: styles.topCard,
    linkTo: linkTo,
    children: /*#__PURE__*/_jsxs("div", {
      "data-testid": loading ? "".concat(testid, "-loading") : testid,
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(WithInfoIcon, {
          showInfo: !!titleInfo,
          info: titleInfo,
          infoTestId: testid && "".concat(testid, "-info"),
          children: /*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            variant: "paragraph1",
            skin: success ? 'success' : 'standard',
            children: title
          })
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        "data-testid": testid && "".concat(testid, "-primary"),
        children: loading ? /*#__PURE__*/_jsx(Spinner, {
          size: 30
        }) : primaryText
      }), secondaryText && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(WithInfoIcon, {
          showInfo: !!secondaryInfo,
          info: secondaryInfo,
          size: "s",
          children: /*#__PURE__*/_jsxs(Typography, {
            variant: "paragraph2",
            skin: "secondary",
            "data-testid": testid && "".concat(testid, "-secondary"),
            children: [loading && /*#__PURE__*/_jsx(Spinner, {
              size: 20
            }), secondaryText]
          })
        })
      })]
    })
  });
}